export default __webpack_public_path__ + "img/miniproback.005e4418.jpg";